import { createContext } from 'react';
import { StepperContextValues } from './types/StepperContextValues';

const OrderStepperContext = createContext<StepperContextValues | undefined>(undefined);

export const OrderStepperProvider = OrderStepperContext.Provider;

export default OrderStepperContext;
